import * as React from 'react';
import {Tab, TabTypes} from "../Tab";
import {ApplicationState} from "../../store";
import {connect} from "react-redux";
import CustomersTab from "../customers/CustomersTab";
import UsersTab from "../users/UsersTab";
import CustomerTab from '../customers/CustomerTab';
import UserTab from "../users/UserTab";
import ServicesTab from '../services/ServicesTab';
import ServiceTab from '../services/ServiceTab';
import CategoriesTab from '../categories/CategoriesTab';
import CategoryTab from '../categories/CategoryTab';
import ContractsTab from "../contracts/ContractsTab";
import ContractTab from "../contracts/ContractTab";
import PaymentsTab from '../payments/PaymentsTab';
import PaymentTab from '../payments/PaymentTab';
import InvoicesTab from "../invoices/InvoicesTab";
import InvoiceTab from "../invoices/InvoiceTab";
import ReportPaymentsInvoicesTab from "../reports/ReportPaymentsInvoicesTab";
import ReportServicesTab from "../reports/ReportServicesTab";
import TenantTab from "../tenant/TenantTab";
import CustomerFinancesTab from "../customers/CustomerFinancesTab";
import DocumentTab from "../documents/DocumentTab";
import DocumentsTab from "../documents/DocumentsTab";
import FolderTab from "../folders/FolderTab";
import IndexingTab from "../documents/IndexingTab";
import DepartmentsTab from "../departments/DepartmentsTab";
import DepartmentTab from "../departments/DepartmentTab";
import PositionsTab from "../positions/PositionsTab";
import PositionTab from "../positions/PositionTab";
import NotificationTab from "../notifications/NotificationTab";
import NotificationsTab from "../notifications/NotificationsTab";
import DocumentsSearchTab from "../documents/DocumentsSearchTab";
import EmployeesTab from "../employees/EmployeesTab";
import EmployeeTab from "../employees/EmployeeTab";
import RolesTab from "../roles/RolesTab";
import RoleTab from "../roles/RoleTab";
import {Dashboard} from "@material-ui/icons";
import DashboardTab from "../dashboard/DashboardTab";

interface ActiveTabComponent {
	tab: React.ReactNode
	id: string
}

export interface ActiveTabProps {
	tab: Tab,
	id?: string
}

export interface ActiveTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		tab: state.tabs.active
	};
}

class ActiveTab extends React.Component<ActiveTabProps, ActiveTabState> {

	private static tabComponents: Array<ActiveTabComponent> = new Array<ActiveTabComponent>();

	constructor(props: ActiveTabProps) {
		super(props)
	}

	componentDidMount() {
	}

	render(): React.ReactNode {

		return (
			<div className='ev-tab-navigation-item'>
				{this.renderTab()}
			</div>
		);
	}

	renderTab (): React.ReactNode {

		if (this.props.tab == null) return (null)

		let activeTabComponent = this.findTabComponentByKey(this.props.tab.id)
		if (activeTabComponent) return activeTabComponent

		let newTabComponent: React.ReactNode = null
		// tab not created yet
		switch (this.props.tab.type.key) {
			case TabTypes.CUSTOMERS.key:
				newTabComponent = <CustomersTab key={this.props.tab.id}/>
				break
			case TabTypes.CUSTOMERS_NEW.key:
				newTabComponent = (<CustomerTab key={this.props.tab.id} />)
				break
			case TabTypes.CUSTOMER_FINANCES.key:
				newTabComponent = (<CustomerFinancesTab key={this.props.tab.id}/>)
				break
			case TabTypes.CONTRACTS.key:
				newTabComponent = (<ContractsTab key={this.props.tab.id} />)
				break
			case TabTypes.CONTRACTS_NEW.key:
				newTabComponent = (<ContractTab key={this.props.tab.id} />)
				break
			case TabTypes.SERVICES.key:
				newTabComponent = <ServicesTab key={this.props.tab.id}/>
				break
			case TabTypes.SERVICES_NEW.key:
				newTabComponent = (<ServiceTab key={this.props.tab.id} />)
				break
			case TabTypes.CATEGORIES.key:
				newTabComponent = <CategoriesTab key={this.props.tab.id}/>
				break
			case TabTypes.CATEGORIES_NEW.key:
				newTabComponent = (<CategoryTab key={this.props.tab.id} />)
				break
			case TabTypes.INVOICES.key:
				newTabComponent = (<InvoicesTab key={this.props.tab.id} />)
				break
			case TabTypes.INVOICES_NEW.key:
				newTabComponent = (<InvoiceTab key={this.props.tab.id} />)
				break
			case TabTypes.PAYMENTS.key:
				newTabComponent = (<PaymentsTab key={this.props.tab.id} />)
				break
			case TabTypes.PAYMENTS_NEW.key:
				newTabComponent = (<PaymentTab key={this.props.tab.id} />)
				break
			case TabTypes.USERS.key:
				newTabComponent = (<UsersTab key={this.props.tab.id} />)
				break
			case TabTypes.USERS_NEW.key:
				newTabComponent = (<UserTab key={this.props.tab.id} />)
				break
			case TabTypes.UAC.key:
				newTabComponent = (<div>uac not implemented</div>)
				break
			case TabTypes.REPORT_INVOICES_PAYMENTS.key:
				newTabComponent = (<ReportPaymentsInvoicesTab key={this.props.tab.id}/>)
				break
			case TabTypes.REPORT_SERVICES.key:
				newTabComponent = (<ReportServicesTab key={this.props.tab.id}/>)
				break
			case TabTypes.TENANT.key:
				newTabComponent = (<TenantTab key={this.props.tab.id}/>)
				break
			case TabTypes.DOCUMENTS.key:
				newTabComponent = (<DocumentsTab key={this.props.tab.id}/>)
				break
			case TabTypes.DOCUMENTS_SEARCH.key:
				newTabComponent = (<DocumentsSearchTab key={this.props.tab.id}/>)
				break
			case TabTypes.DOCUMENT_NEW.key:
				newTabComponent = (<DocumentTab key={this.props.tab.id}/>)
				break
			case TabTypes.DOCUMENTS_INDEXING.key:
				newTabComponent = (<IndexingTab key={this.props.tab.id}/>)
				break
			case TabTypes.FOLDERS_NEW.key:
				newTabComponent = (<FolderTab key={this.props.tab.id}/>)
				break
			case TabTypes.DEPARTMENTS.key:
				newTabComponent = <DepartmentsTab key={this.props.tab.id}/>
				break
			case TabTypes.DEPARTMENTS_NEW.key:
				newTabComponent = (<DepartmentTab key={this.props.tab.id} />)
				break
			case TabTypes.POSITIONS.key:
					newTabComponent = <PositionsTab key={this.props.tab.id}/>
					break
			case TabTypes.POSITIONS_NEW.key:
					newTabComponent = (<PositionTab key={this.props.tab.id} />)
					break
			case TabTypes.NOTIFICATIONS.key:
					newTabComponent = <NotificationsTab key={this.props.tab.id}/>
					break
			case TabTypes.NOTIFICATIONS_NEW.key:
					newTabComponent = (<NotificationTab key={this.props.tab.id} />)
					break
			case TabTypes.EMPLOYEES.key:
				newTabComponent = <EmployeesTab key={this.props.tab.id}/>
				break
			case TabTypes.EMPLOYEES_NEW.key:
				newTabComponent = (<EmployeeTab key={this.props.tab.id} />)
				break
			case TabTypes.ROLES.key:
				newTabComponent = (<RolesTab key={this.props.tab.id} />)
				break
			case TabTypes.ROLES_NEW.key:
				newTabComponent = (<RoleTab key={this.props.tab.id} />)
				break
			case TabTypes.DASHBOARD.key:
				newTabComponent = (<DashboardTab key={this.props.tab.id} />)
				break
			default:
				newTabComponent = (<div>not implemented</div>)
				break
		}
		ActiveTab.tabComponents.push({tab: newTabComponent, id: this.props.tab.id})
		return newTabComponent
	}

	private findTabComponentByKey (id: string): React.ReactNode {
		let tabComponents: ActiveTabComponent[] = ActiveTab.tabComponents.filter(x => x.id == id)
		if (tabComponents.length > 0) return tabComponents[0].tab
		return null
	}
}

export default connect(mapStateToProps)(ActiveTab)
